import styled from 'styled-components'

import { theme } from '@/styles/theme'

import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { Video } from '@/components/elements/Video'
import { TitleLayout } from '@/components/layout'
import { Head } from '@/components/layouts/Head'

import { VideoInfo } from '@/types/video'

type VideoProps = {
  videoInfoList: readonly VideoInfo[]
}

export const VideoPage = ({ videoInfoList }: VideoProps) => {
  const pageTitle = {
    title: 'NEWS ROOM',
    subTitle: 'ニュースルーム',
  }

  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: 'ニュースルーム', path: '/news' },
    { name: 'ビデオライブラリー', path: '' },
  ]

  return (
    <>
      <Head
        title="ビデオライブラリー"
        description="トライアルホールディングスのプロモーションビデオをご視聴いただけます。"
        ogp={{ type: 'article', url: 'news/video/' }}
      />
      <TitleLayout
        {...pageTitle}
        breadCrumbs={breadCrumbs}
        isRequiredBackground
      >
        <Container>
          <SectionTitle
            titleText="Video Library"
            subTitleText="ビデオライブラリー"
            color="normal"
          />
          <Spacer h={{ sp: 50, pc: 63 }} />
          <CategoryTitle>戦略紹介動画</CategoryTitle>
          <Spacer h={{ sp: 40, pc: 52 }} />
          {videoInfoList.length > 0 && (
            <VideoList>
              {videoInfoList.map(({ title, url }) => (
                <VideoItem key={url}>
                  <Video title={title} src={url} />
                  <VideoTitle>{title}</VideoTitle>
                </VideoItem>
              ))}
            </VideoList>
          )}
        </Container>
      </TitleLayout>
    </>
  )
}

const Container = styled.div`
  width: 1040px;
  padding: 70px 0 130px;
  margin: 0 auto;

  @media screen and (max-width: 1047px) {
    padding: 40px 20px 80px;
    width: 100%;
  }
`

const CategoryTitle = styled.h4`
  font-size: 28px;
  font-weight: bold;
  letter-spacing: 1.68px;
  line-height: 42px;
  color: ${theme.colors.trialBlue};

  @media screen and (max-width: 1047px) {
    font-size: 20px;
    letter-spacing: 1.2px;
    line-height: 28px;
  }
`

const VideoItem = styled.div`
  width: 316px;

  @media screen and (max-width: 1047px) {
    width: 350px;
  }
`

const VideoList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 46px;
`

const VideoTitle = styled.div`
  font-size: 16px;
  letter-spacing: 1.6px;
  line-height: 22px;
  color: ${theme.colors.textTitle};
  margin-top: 14px;

  @media screen and (max-width: 1047px) {
    letter-spacing: 0.96px;
    margin-top: 10px;
  }
`
